module.exports = __webpack_public_path__ + "static/media/About-Us_Home.d448582c.jpg";